<template lang="pug">
    .user-item(:class="{ 'registration': _id === null }")
        button.device(v-if="_id && devices.length" @click="togleDevices") 
            span.icon 
                i.fas(:class="showDevices ? 'fa-chevron-up' : 'fa-chevron-down'")
            | {{ devices.length }}
        button.delete.action(v-if="_id" @click="remove")
        button.button.is-small.is-dark.action(v-else @click="create")
          span.icon.has-text-success
            i.fas.fa-check-square
        .columns.is-variable.is-2-desktop.is-8-fullhd
            .column.is-2
                .subtitle.is-6 Username
                EditInput(:value="username" @input="input('username', $event)" type="text")
            .column.is-2
                .subtitle.is-6 E-mail
                EditInput(:value="email" @input="input('email', $event)" type="email" is-link)
            .column.is-2
                .subtitle.is-6 TelegramID
                EditInput(:value="telegramID" @input="input('telegramID', $event)" type="text")
            .column.is-2(v-if="!_id")
                .subtitle.is-6 Password
                EditInput(:value="password" @input="input('password', $event)" type="text")
            .column.is-2(v-if="_id")
                .subtitle.is-6.level.is-mobile
                  .level-left Subscriptions
                  .level-right
                    .level-item.dropdown.is-right(:class="{ 'is-active': showBotList }" v-if="hasActiveSub")
                      .dropdown-trigger
                        button.button.is-small(aria-haspopup="true" aria-controls="dropdown-menu" @click="showBotList = !showBotList")
                          span.icon
                            i.fas.fa-robot
                      .dropdown-menu(:id="`body-${_id}`" role="menu")
                        .dropdown-content
                          a.dropdown-item(v-for="(value, bot) of bots" :class="{ 'is-active': value }" @click="toggleBot(bot, !value)") {{ bot }}
                .active-sub.level.is-mobile(v-for="s in activeSubscriptions" :key="s._id")
                    .level-left
                        span.sub-name {{ s.name }}
                    .level-right
                        button.delete.is-small(@click="deleteSub(s._id)")
                EditInput(value="0" @input="addSub($event)" is-select :select="subs")
            .column.is-2
                .subtitle.is-6 Subscription end
                .active-sub-end(v-for="s in activeSubscriptions" :key="s._id") {{ dateFormat(s.endedAt) }}
                .has-text-grey(v-if="!activeSubscriptions.length") Expired
            .column.is-2
                .subtitle.is-6 Registration date
                .has-text-weight-semibold.is-size-5-fullhd.is-size-5-desktop {{ dateFormat(registrationOn) }}
        ul.devices(v-show="showDevices")
            li.columns.is-variable.is-1-desktop.is-20-fullhd(v-for="(device, index) in devices" :key="device._id")
                .column.is-3
                    .subtitle.is-6( v-if="!index") uuid
                    span {{device._id}} 
                .column.is-2
                    .subtitle.is-6( v-if="!index") name
                    span {{device.name}} 
                .column.is-2
                    .subtitle.is-6( v-if="!index") last active date
                    span {{dateTimeFormat(device.updatedAt)}} 
                .column.is-1
                    .subtitle.is-6( v-if="!index") is login
                    i.fas(:class="device.refreshToken ? 'fa-check text-success' : ''")
                .column.is-1
                    .subtitle.is-6( :class="{'is-hidden': index}") {{". "}}
                    button.delete.is-large( @click="removeDevice(device._id)") 

</template>

<script>
import moment from "moment";
import EditInput from "@/components/EditInput";

export default {
  name: "UserItem",
  components: {
    EditInput
  },
  data: () => ({
    showBotList: false,
    showDevices: false,
    // оптимистичные оверрайды тумблеров ботов для мгновенного отклика;
    // сбрасываются при получении свежих пропсов с сервера
    botOverride: {},
  }),
  props: {
    _id: {
      type: String
    },
    username: {
      type: String
    },
    email: {
      type: String
    },
    password: {
      type: String
    },
    telegramID: {
      type: String
    },
    subscriptions: {
      type: Array
    },
    registrationOn: {
      type: String
    },
    liveBot: {
      type: Boolean,
      default: true
    },
    tickerBot: {
      type: Boolean,
      default: true
    },
    raiseBot: {
      type: Boolean,
      default: true
    },
    crashBot: {
      type: Boolean,
      default: true
    },
    prematchBot: {
      type: Boolean,
      default: true
    },
    stripeId: {
      type: String
    },
    devices: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    bots() {
      const pick = bot =>
        bot in this.botOverride
          ? this.botOverride[bot]
          : this[`${bot}Bot`];
      return {
        live: pick("live"),
        ticker: pick("ticker"),
        raise: pick("raise"),
        crash: pick("crash"),
        prematch: pick("prematch")
      };
    },
    // сигнатура bot-пропсов: меняется, когда сервер вернул обновление
    botPropsSignature() {
      return [
        this.liveBot,
        this.tickerBot,
        this.raiseBot,
        this.crashBot,
        this.prematchBot
      ].join(",");
    },
    // A-16: все активные подписки юзера с именем плана из каталога
    activeSubscriptions() {
      const now = Date.now();
      const catalog = this.$store.state.subscription.list || [];
      return (this.subscriptions || [])
        .filter(
          s => s.status === "active" && moment(s.endedAt).valueOf() >= now
        )
        .map(s => {
          const plan = catalog.find(
            p => p._id === s.subscription || p.key === s.type
          );
          return {
            _id: s._id,
            name: plan ? plan.name : s.type,
            endedAt: s.endedAt
          };
        });
    },
    hasActiveSub() {
      return this.activeSubscriptions.length > 0;
    },
    subs() {
      // для добавления — только платные планы (системные статусы назначать нельзя)
      return [
        {
          _id: "0",
          name: "Add subscription"
        },
        ...(this.$store.state.subscription.list || []).filter(s => !s.isSystem)
      ];
    }
  },
  watch: {
    // сервер вернул обновление — сбрасываем оптимистичные оверрайды
    botPropsSignature() {
      this.botOverride = {};
    }
  },
  methods: {
    toggleBot(bot, status) {
      // мгновенный визуальный отклик до ответа сервера
      this.$set(this.botOverride, bot, status);
      let res = Object.assign({}, this.$props, { [`${bot}Bot`]: status });
      this.$emit("update", res);
    },
    dateFormat(date) {
      return moment(date).calendar();
    },
    dateTimeFormat(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    create() {
      this.$emit("create", this.$props);
    },
    remove() {
      this.$emit("remove", this._id);
    },
    removeDevice(id) {
      this.$emit("removeDevice",{ userId: this._id, id});
    },
    togleDevices() {
      this.showDevices = !this.showDevices;
    },
    input(type, value) {
      const obj = type
        .split(".")
        .reverse()
        .reduce((r, k) => {
          return Object.keys(r).length ? { [k]: r } : { [k]: value };
        }, {});
      let res = Object.assign({}, this.$props, obj);
      this.$emit("update", res);
    },
    // A-16: добавить подписку (append новой записи на сервере)
    addSub(subscriptionId) {
      if (!subscriptionId || subscriptionId === "0" || subscriptionId === 0) {
        return;
      }
      this.$emit("addSub", { userId: this._id, subscriptionId });
    },
    // A-16: удалить конкретную подписку
    deleteSub(subId) {
      this.$emit("deleteSub", subId);
    }
  }
};
</script>

<style lang="scss" scoped>
.user-item {
  position: relative;
  padding: 1rem 2rem;
  margin-bottom: 1rem;
  background-color: #4e5962;

  &.registration {
    background-color: #363636;
  }

  .action {
    position: absolute;
    right: 1rem;
  }

  .columns {
    .column {
      .subtitle {
        margin-bottom: 1rem;

        & + .title {
          margin-top: 0;
        }
      }
    }
  }
}
.devices{
    width: 100%;
    .column{
        padding: 0;
    }
}
.device{
  position: absolute;
    right: 1rem;
    bottom: 1rem;
}
.active-sub {
  margin-bottom: 0.4rem;
  .sub-name {
    word-break: break-word;
    margin-right: 0.5rem;
  }
}
.active-sub-end {
  font-weight: 600;
  margin-bottom: 0.4rem;
}
</style>
